/* AKKAYA Bewegung: Karten unter dem ersten Sichtfeld erscheinen beim Scrollen (IntersectionObserver), gestaffelt je Elterngruppe.
   Nichts wird versteckt, was beim Laden schon sichtbar ist; ohne Observer oder mit reduced-motion passiert nichts. 25.09.2026
   WIG-Fund 9: erst alle Masse lesen, dann schreiben (kein Wechsel Lesen/Schreiben in einer Schleife). */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var selektoren = [
    '.akm__kat-raster > *', '.akm__produkte > *', '.akp', '.akm__banner > *', '.akv-o__banner3 > *', '.akm__band',
    '.akn__set-inner', '.akn__fragen-raster > *', '.akn__warum-inner > *', '.akm__vertrauen-inner > *', '.akm__fakten > *',
    '.aks__orte-liste > li', '.aks__schritte > li', '.aks__video', '.ak4__wege > li',
    '.m-collection-products .m-product-card', '.m-search-page .m-product-card', '.ak-karte', '.ak-sort__karte', '.ak-uk__raster > li', '.m-collection--wrapper .m-product-card',
    '.ak-zubehoer__item', '.akb-usp__item', '.akw__item', '.akw__karte', '.ak-ratgeber__block',
    '.m-contact-form__main', '.m-contact-form__info > *'
  ];
  var alle = document.querySelectorAll(selektoren.join(','));
  if (!alle.length) return;
  var vh = window.innerHeight || 800;
  /* Lesen */
  var kandidaten = [];
  alle.forEach(function (el) {
    if (el.classList.contains('ak-reveal')) return;
    kandidaten.push({ el: el, top: el.getBoundingClientRect().top });
  });
  /* Schreiben */
  var gruppen = new Map();
  var wartend = [];
  kandidaten.forEach(function (k) {
    if (k.top < vh * 0.92) return; /* schon im Sichtfeld: bleibt, wie es ist */
    var eltern = k.el.parentElement || document.body;
    var n = gruppen.get(eltern) || 0;
    k.el.style.setProperty('--ak-verz', (Math.min(n, 5) * 0.06).toFixed(2) + 's');
    gruppen.set(eltern, n + 1);
    k.el.classList.add('ak-reveal');
    wartend.push(k.el);
  });
  if (!wartend.length) return;
  /* Nach dem Erscheinen die Klassen entfernen, sonst blockiert .ak-da{transform:none} das Hover-Anheben (Kategorie-Agent 25.09.) */
  function aufraeumen(el) {
    setTimeout(function () { el.classList.remove('ak-reveal', 'ak-da'); el.style.removeProperty('--ak-verz'); }, 950);
  }
  var io = new IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('ak-da'); io.unobserve(e.target); aufraeumen(e.target); }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  wartend.forEach(function (el) { io.observe(el); });
  /* Sicherheitsnetz: was nach 3 s im Sichtfeld steht, wird gezeigt, auch wenn der Observer schweigt */
  setTimeout(function () {
    var h = window.innerHeight || 800;
    var zeigen = wartend.filter(function (el) {
      if (el.classList.contains('ak-da')) return false;
      var r = el.getBoundingClientRect();
      return r.top < h && r.bottom > 0;
    });
    zeigen.forEach(function (el) { el.classList.add('ak-da'); });
  }, 3000);
})();
